import { makeStyles } from "tss-react/mui";

const useHeaderFieldStyles = makeStyles()((theme) => ({
  bgColor: {
    backgroundColor: theme.palette.surface.light,
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    lineHeight: "23px",
    alignItems: "center",
    width: "100%",
    backgroundColor: theme.palette.surface.light,
    color: theme.palette.text.primary,

    "& .iconA": {
      backgroundColor: theme.palette.status.status1,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconP": {
      backgroundColor: theme.palette.status.status2,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconK": {
      backgroundColor: theme.palette.status.status3,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconN": {
      backgroundColor: theme.palette.status.status4,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconR": {
      backgroundColor: theme.palette.status.status5,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconL": {
      backgroundColor: theme.palette.status.status6,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconS": {
      backgroundColor: theme.palette.status.status7,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },

    "& .iconX": {
      backgroundColor: theme.palette.status.status8,
      color: "rgba(255,255,255,1)",
      padding: "0 3px",
      width: "18px",
      textAlign: "center",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },
  },
  left: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden",
    fontWeight: "500",
    width: "100%",
  },
  right: {
    display: "flex",
    flexDirection: "column",
    textAlign: "right",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
    gap: "1px",
  },
  rightElement: {
    borderRadius: "4px",
    backgroundColor: theme.palette.surface.bg,
    display: "flex",
    minWidth: "2em",
    justifyContent: "space-between",

    "& div:first-of-type": {
      flexGrow: 1,
      padding: "0 6px",
      textAlign: "right",
    },

    "& > div": {
      padding: "0.1em",
      fontSize: "16px",
    },
  },
  bottomLeft: {
    fontSize: "14px",
    fontWeight: "400",
    width: "100%",
  },
  columnsRight: {
    display: "flex",
    flexDirection: "column",
    paddingRight: "2px",
  },
  grey: {
    margin: "0px 15px",
  },
  limitedHeight: {
    height: "58.8px",
    margin: "5px 0",
  },
  noWrap: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  noColor: {
    backgroundColor: "inherit",
    paddingLeft: "15px",
    paddingRight: "15px",
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
  },
  arrow: {
    lineHeight: "5px",
  },
  lines: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  expand: {
    paddingTop: "5px",
    paddingBottom: "5px",
  },
}));

export default useHeaderFieldStyles;
